import React, { useEffect, useState } from "react";
import BaseTooltipWrapper from "@/components/BaseWrappers/BaseTooltipWrapper";
import FormErrorMessage from "@/components/FormErrorMessage/FormErrorMessage";
import { createChallengeTooltipsText } from "@/features/challenge/utils/CreateChallengeTooltips";
import { Flex, Heading, RadioCards, Text } from "@radix-ui/themes";
import { InfoCircledIcon } from "@radix-ui/react-icons";

type GeneralInputValuesProps = { text: string; value: string; desc?: string }[];

export const RadioInputsGroup: React.FunctionComponent<{
  name: string;
  options: GeneralInputValuesProps;
  label: string;
  error: string | undefined;
  setFieldValue: any;
  initVal: string;
}> = ({ options, name, label, error, setFieldValue, initVal }) => {
  const [challType, setChallType] = useState<any>(undefined);
  useEffect(() => {
    setChallType(initVal);
  }, [initVal]);
  return (
    <Flex gap="2" direction="column">
      <BaseTooltipWrapper
        overlayTrigger={
          <Flex align="center" gap="1">
            <Heading as="h3" size="4">
              {label}
            </Heading>
            <InfoCircledIcon />
          </Flex>
        }
        tooltipContent={createChallengeTooltipsText[name]}
      />
      <Flex gap="3" align="center">
        <RadioCards.Root
          defaultValue={initVal}
          columns={{ initial: "1", sm: "3" }}
        >
          {initVal &&
            challType &&
            options.map((option) => (
              <RadioCards.Item
                value={option.value}
                key={option.value}
                onClick={(e: any) => {
                  setChallType(e.target.value);
                  setFieldValue(name, e.target.value);
                }}
              >
                <Flex direction="column">
                  <Text weight="bold">{option.text}</Text>
                  <Text size="1" color="gray">
                    {option.desc}
                  </Text>
                </Flex>
              </RadioCards.Item>
            ))}
        </RadioCards.Root>
      </Flex>
      <FormErrorMessage text={error} isVisible={!!error} />
    </Flex>
  );
};
